import React from 'react';
import { motion } from 'framer-motion';
import { useI18n } from '../lib/i18n';
import { HeroCanvas } from './HeroCanvas';
import { ChevronDown } from 'lucide-react';
export function Hero() {
  const {
    t
  } = useI18n();
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-114">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-violet-dark/10 via-background to-background" data-id="element-115" />
      <HeroCanvas data-id="element-116" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 text-center flex flex-col items-center" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-white/10 bg-white/5 backdrop-blur-sm mb-8" data-id="element-118">
          <span className="w-2 h-2 rounded-full bg-violet-electric animate-pulse" data-id="element-119" />
          <span className="text-xs font-mono text-gray-300 uppercase tracking-wider" data-id="element-120">
            {t('hero.eyebrow')}
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="font-display text-7xl md:text-9xl lg:text-[12rem] leading-none tracking-tight text-white mb-6 text-glow" data-id="element-121">
          CLVN–LRR™
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="text-xl md:text-2xl text-gray-300 max-w-3xl font-light leading-relaxed mb-6" data-id="element-122">
          {t('hero.subtitle')}
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5,
        ease: 'easeOut'
      }} className="text-sm md:text-base text-gray-500 max-w-2xl mb-12" data-id="element-123">
          {t('hero.description')}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6,
        ease: 'easeOut'
      }} className="flex flex-wrap items-center justify-center gap-4" data-id="element-124">
          <button onClick={() => scrollTo('marco')} className="px-8 py-3 bg-white text-black font-medium rounded-full hover:bg-gray-200 transition-colors" data-id="element-125">
            {t('hero.btnExplore')}
          </button>
          <button onClick={() => scrollTo('papers')} className="px-8 py-3 bg-surface border border-white/10 text-white font-medium rounded-full hover:bg-white/5 transition-colors" data-id="element-126">
            {t('hero.btnPaper')}
          </button>
          <button onClick={() => scrollTo('aplicaciones')} className="px-8 py-3 text-gray-400 hover:text-white font-medium transition-colors" data-id="element-127">
            {t('hero.btnApps')}
          </button>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 text-gray-500 animate-bounce cursor-pointer" onClick={() => scrollTo('marco')} data-id="element-128">
        <ChevronDown size={24} data-id="element-129" />
      </motion.div>
    </section>;
}